import { DebugPin } from '../../../../../../../../../shared/application/components/DebugPing/PlayAppVersion';
import { Wrapper } from './Header.styled';

export const Header = ({ disablePointerEvents }: { disablePointerEvents?: boolean }) => {
  return (
    <Wrapper $disablePointerEvents={disablePointerEvents}>
      <DebugPin />
    </Wrapper>
  );
};
